import React from 'react';
import $ from 'jquery';
import OrderService from '../services/order.js';
import CurrencyService from '../services/currency.js';
import Utility from '../utilities/utility.js';
import AuthorizationCheck from '../auth/authorizationCheck.js';
import CountryService from '../services/country';
import { Modal } from 'react-bootstrap';
import CustomerService from '../services/customer.js';
import BranchService from '../services/branch.js';

class NewStockOrder extends React.Component {

    constructor(props) {

        super(props);

        this.currencyService = new CurrencyService();
        this.countryService = new CountryService();
        this.customerService = new CustomerService();
        this.branchService = new BranchService();

        this.state = {
            item: '',
            currencies: [],
            countries: [],
            customers: [],
            timeoutId: null,
            showCustomerList: false,
            branches: [],
        }
    }

    componentDidMount() {

        this.currencyList();
        this.countryList();
    }

    showCustomers = () => {



        this.setState({
            showCustomerList: true
        });
    }

    hideCustomers = () => {


        this.setState({
            showCustomerList: false
        });
    }

    findClients = () => {



        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.customerList();
        }, 1000);

        this.setState({ timeoutId: timer })



    }

    customerList = async () => {



        try {

            let searchTerm = $('#searchTerm').val();

            let countryId = $('#countryId').val();

            const res = await this.customerService.customerList(countryId, searchTerm);

            if (res.ok) {

                this.setState({

                    customers: await res.json()
                });
            }



        } catch (error) {

            console.log(error);

        }


    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    countryList = async () => {

        try {

            const res = await this.countryService.fetchCountries();

            this.setState({
                countries: await res.json()
            });

        } catch (error) {
            console.log(error);
        }


    }

    async createOrder() {

        try {

            let description = $('#descriptionId').val();

            let currencyId = $('#currencyId').val();

            let countryId = $('#countryId').val();

            let customerId = $('#customerId').val();
            let branchId = $('#branchId').val();

            if (Utility.isEmpty(description) || Utility.isEmpty(currencyId) || Utility.isEmpty(countryId) | Utility.isEmpty(branchId)) {

                $('.messageHolder').html(

                    '<div class="alert alert-danger order-alert">Entrer la description, la devise,  choisissez le pays et la branche </div>'
                );

                $('.order-alert').delay(3000).fadeOut('slow');

                return;
            }

            $('#customerId').val('');

            $('#selectedCustomer').html('');


            const response = await OrderService.createSockOrder(description, currencyId, countryId, customerId, branchId);

            if (response.ok) {

                $('.messageHolder').html(

                    '<div class="alert alert-success">Nouvelle commande crée</div>'
                );
            } else {

                $('.messageHolder').html(

                    '<div class="alert alert-danger">Erreur</div>'
                );

            }
        } catch (error) {


            console.log(error);
            $('.messageHolder').html(

                '<div class="alert alert-danger">Erreur</div>'
            );
        }





    }

    currencyList = async () => {

        try {

            const response = await this.currencyService.currencyList();

            this.setState({

                currencies: await response.json()
            })

        } catch (error) {
            console.log(error)
        }

    }

    selectCustomer = (customerId, name, address) => {

        $('#customerId').val(customerId);
        $('#selectedCustomer').html('<div class="float-start">Nom: ' + name + '</div class="float-start"><div> Address: ' + address + '</div>');

        this.hideCustomers();
    }


    branchList = async () => {

        try {

            let countryId = $('#countryId').val();

            if (Utility.isEmpty(countryId)) {

                Utility.showAlertWithId('errorHolder', 'Veillez choisir le pays', 'danger', true);

                return;
            }
            let name = $('#searchName').val();

            const response = await this.branchService.branchList(countryId, name);

            this.setState({

                branches: await response.json()
            });
        } catch (error) {

            console.log(error);
        }


    }

    render() {



        const { item } = this.state;

        const currencies = this.state.currencies;

        const countries = this.state.countries;

        const customers = this.state.customers;

        const branches = this.state.branches;


        return (


            <div className="order-wrapper">
                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />

                <input type='hidden' id='customerId' />
                <div className="form-wrapper">
                    <h2>Nouvelle Cargo Commande</h2>

                    <div className="messageHolder"></div>

                    <div className="form-group">
                        <input className="form-control" id="descriptionId" placeholder="Description" />
                    </div>

                    <div className="form-group">
                        <label className="label">Choisi le Pays</label>
                        <select className="form-control" id="countryId" onChange={this.branchList} >
                            <option></option>
                            {countries.length > 0 && countries.map(country =>

                                <option key={country.countryId} value={country.countryId}>{country.name}</option>
                            )}
                        </select>
                    </div>

                    <div className="form-group">
                        <label className='label'>Devise</label>
                        <select className="form-control" id="currencyId" >
                            <option></option>
                            {currencies != undefined && currencies.length > 0 && currencies.map(currency =>

                                <option key={currency.currencyId} value={currency.currencyId}>{currency.name}</option>

                            )}
                        </select>
                    </div>

                    <div className='form-group'>

                        <label className='label'>Branches</label>

                        <select className='form-control' id='branchId'>
                            <option></option>

                            {branches.length > 0 && branches.map(branch =>

                                <option value={branch.branchId}> {branch.name} </option>

                            )}

                        </select>



                    </div>

                    <div className="form-group" id='selectedCustomer'>

                    </div>

                    <div className="form-group">
                        <input className="form-control" onKeyDown={(e) => this.showCustomers(e)} placeholder="Recherche Client" />
                    </div>


                    <div className="form-group">
                        <button className="btn btn-primary" onClick={this.createOrder}>Creer Commande</button>
                    </div>


                </div>

                <Modal show={this.state.showCustomerList} size='lg'>
                    <Modal.Header closeButton onHide={this.hideCustomers}>Recherche Client</Modal.Header>
                    <Modal.Body>

                        <div className="form-group">
                            <input className="form-control" id="searchTerm" onKeyUp={this.findClients} placeholder="Nom du client" />
                        </div>

                        {customers.length > 0 && customers.map(customer =>

                            <div className="card card-default mt-2" key={customer.customerId}>

                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">{customer.name}</div>

                                        <div className="col">{customer.address}</div>


                                        <div className="col">
                                            <button className="btn btn-primary" onClick={() => this.selectCustomer(customer.customerId, customer.name, customer.address)}>Choisi</button>
                                        </div>



                                    </div>
                                </div>

                            </div>


                        )}




                    </Modal.Body>

                </Modal>



            </div>




        );
    }
}

export default NewStockOrder;